import { Typography } from "@mui/material";
import ImageWithFooterCardStyles from "./ImageWithFooterCard.styles";

const ImageWithFooterCard = (props) => {
  const { image, footer, href } = props;
  const classes = ImageWithFooterCardStyles();

  return (
    <a href={href.route} className={classes.linkContainer}>
      <div className={classes.container}>
        <div className={classes.imageContainer}>
          <img {...image} />
        </div>
        <div className={classes.footer}>
          <Typography variant="body_strong_black">{footer}</Typography>
        </div>
      </div>
    </a>
  );
};

export default ImageWithFooterCard;
